import * as yup from 'yup';
import { usernameValidationSchema } from 'global/validators';

export const findSocialValidationSchema = yup.object().shape({
  userName: usernameValidationSchema.required('validations.username.required'),
});

export default findSocialValidationSchema;
